<template>
  <div id="app" class="ysr-page">
    <hatadialog ref="hatadialog"></hatadialog>
    <genelfiltre ref="genelfiltre"></genelfiltre>

    <v-app id="inspire" light class="ysr-app">
      <!-- =====================================================
           SAYFA BAŞLIĞI
           ===================================================== -->
      <div class="ysr-hero">
        <div>
          <span class="ysr-eyebrow">COPER / {{ $t('Reports') }}</span>
          <h1>{{ $t('New-Sales-Report') }}</h1>
          <p>
            {{ $t('New-Sales-Report-Description')
            }}
          </p>
        </div>

        <div class="ysr-engine-badge">
          <v-icon>verified_user</v-icon>
          <div>
            <small>{{ $t('Calculation-Source') }}</small>
            <strong>{{ $t('New-Quotation') }}</strong>
          </div>
        </div>
      </div>

      <v-container fluid class="ysr-container">
        <v-form ref="formYeniSatisRaporu" v-model="valid" lazy-validation>

          <!-- =================================================
               FİLTRELER
               ================================================= -->
          <section class="ysr-card ysr-filter-card">
            <div class="ysr-card-heading">
              <div class="ysr-heading-icon">
                <v-icon>tune</v-icon>
              </div>

              <div>
                <h2>{{ $t('Report-Parameters') }}</h2>
                <p>
                  {{ $t('Sales-Report-Filter-Description') }}
                </p>
              </div>

              <v-spacer></v-spacer>

              <v-chip
                v-if="filtrevarmi"
                small
                color="green"
                text-color="white"
              >
                <v-icon left small>check_circle_outline</v-icon>
                {{ $t('Additional-Filter-Active') }}
              </v-chip>
            </div>

            <v-layout row wrap align-center class="ysr-filter-grid">
              <v-flex xs12 sm6 md2 class="ysr-field">
                <v-select
                  :label="$t('Date-Type')"
                  item-value="value"
                  item-text="text"
                  :items="itemstarihtip"
                  v-model="tarihTip"
                  solo
                  flat
                  hide-details
                ></v-select>
              </v-flex>

              <v-flex xs12 sm6 md2 class="ysr-field">
                <tarihcomp
                  :etiket="$t('Starting-Date')"
                  :detaygizle="false"
                  :rules="dateRules"
                  :defaultvalue="'ok'"
                  :value="KayitTarihiBasla"
                  v-model="KayitTarihiBasla"
                ></tarihcomp>
              </v-flex>

              <v-flex xs12 sm6 md2 class="ysr-field">
                <tarihcomp
                  :etiket="$t('Finishing-Date')"
                  :detaygizle="false"
                  :rules="dateRules"
                  :defaultvalue="'ok'"
                  :value="KayitTarihiBitis"
                  v-model="KayitTarihiBitis"
                ></tarihcomp>
              </v-flex>

              <v-flex xs12 sm6 md3 class="ysr-field">
                <div class="ysr-mode-switch">
                  <button
                    type="button"
                    class="ysr-mode-btn"
                    :class="{ 'ysr-mode-btn-active': raporModu === 'detay' }"
                    @click="raporModu = 'detay'"
                  >
                    <v-icon small>view_list</v-icon>
                    {{ $t('Item-Detail') }}
                  </button>

                  <button
                    type="button"
                    class="ysr-mode-btn"
                    :class="{ 'ysr-mode-btn-active': raporModu === 'pnr' }"
                    @click="raporModu = 'pnr'"
                  >
                    <v-icon small>assessment</v-icon>
                    {{ $t('PNR-Total') }}
                  </button>
                </div>
              </v-flex>

              <v-flex xs12 sm6 md3 class="ysr-field">
                <div class="ysr-filter-actions">
                  <v-btn
                    class="ysr-secondary-btn"
                    outline
                    color="info"
                    @click="filtrele"
                  >
                    <v-icon left small>filter_list</v-icon>
                    {{ $t('General-Filter') }}
                  </v-btn>

                  <v-btn
                    class="ysr-primary-btn"
                    color="info"
                    dark
                    :loading="progress"
                    @click="getList"
                  >
                    <v-icon left small>search</v-icon>
                    {{ $t('Get-Report') }}
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </section>

          <!-- =================================================
               HESAPLAMA BİLGİSİ
               ================================================= -->
          <section class="ysr-rule-strip">
            <div class="ysr-rule-icon">
              <v-icon>functions</v-icon>
            </div>

            <div class="ysr-rule-copy">
              <strong>{{ $t('New-Calculation-Rule') }}</strong>
              <span>
                {{ $t('New-Calculation-Rule-Description')
                }}
              </span>
            </div>

            <div class="ysr-rule-examples">
              <span><b>PAX:</b> {{ $t('Person-Based') }}</span>
              <span><b>FIX:</b> {{ $t('Room-Vehicle-Quantity-Based') }}</span>
            </div>
          </section>

          <!-- =================================================
               ÖZET KARTLARI
               ================================================= -->
          <v-layout row wrap class="ysr-summary-grid">
            <v-flex xs12 sm6 md3 class="ysr-summary-cell">
              <div class="ysr-summary-card ysr-sales-card">
                <div class="ysr-summary-icon">
                  <v-icon>trending_up</v-icon>
                </div>
                <div>
                  <span>{{ $t('Total-Sales') }}</span>
                  <strong>{{ formatMoneyDisplay(toplamSatis) }} {{ paraBirimi }}</strong>
                </div>
              </div>
            </v-flex>

            <v-flex xs12 sm6 md3 class="ysr-summary-cell">
              <div class="ysr-summary-card ysr-cost-card">
                <div class="ysr-summary-icon">
                  <v-icon>trending_down</v-icon>
                </div>
                <div>
                  <span>{{ $t('Total-Cost') }}</span>
                  <strong>{{ formatMoneyDisplay(toplamAlis) }} {{ paraBirimi }}</strong>
                </div>
              </div>
            </v-flex>

            <v-flex xs12 sm6 md3 class="ysr-summary-cell">
              <div class="ysr-summary-card ysr-profit-card">
                <div class="ysr-summary-icon">
                  <v-icon>account_balance_wallet</v-icon>
                </div>
                <div>
                  <span>{{ $t('Net-Profit') }}</span>
                  <strong>{{ formatMoneyDisplay(toplamKar) }} {{ paraBirimi }}</strong>
                </div>
              </div>
            </v-flex>

            <v-flex xs12 sm6 md3 class="ysr-summary-cell">
              <div class="ysr-summary-card ysr-pnr-card">
                <div class="ysr-summary-icon">
                  <v-icon>folder_open</v-icon>
                </div>
                <div>
                  <span>PNR / {{ $t('Passenger') }}</span>
                  <strong>{{ toplamPnr }} PNR · {{ toplamYolcu }} {{ $t('Passenger') }}</strong>
                </div>
              </div>
            </v-flex>
          </v-layout>

          <!-- =================================================
               RAPOR TABLOSU
               ================================================= -->
          <section class="ysr-card ysr-table-card">
            <div class="ysr-table-header">
              <div>
                <span class="ysr-eyebrow-dark">
                  {{ raporModu === 'pnr' ? $t('PNR-Based-Summary') : $t('Item-Based-Detail') }}
                </span>
                <h2>
                  {{ raporModu === 'pnr' ? $t('PNR-Totals') : $t('Sales-and-Cost-Details') }}
                </h2>
              </div>

              <div class="ysr-table-count">
                {{ currentItems.length }} {{ $t('Record') }}
              </div>
            </div>

            <ReportTable
              :headers="currentHeaders"
              :items="currentItems"
              :loading="progress"
              :has-searched="hasSearched"
              :storage-key="reportTableStorageKey"
              :search-label="$t('Search')"
              :show-frontend-export="true"
              :rows-per-page-items="[20, 50, 100]"
              :excel-summary-config="excelSummaryConfig"
              class="ysr-report-table"
            >
              <template slot="cell" slot-scope="slotProps">
                <!-- Hesap tipi -->
                <div
                  v-if="slotProps.column && slotProps.column.value === 'HesapTipi'"
                  class="ysr-cell-center"
                >
                  <span
                    class="ysr-type-pill"
                    :class="hesapTipiClass(slotProps.value)"
                  >
                    {{ slotProps.value || $t('Total') }}
                  </span>
                </div>

                <!-- Teknik hesap -->
                <div
                  v-else-if="slotProps.column && slotProps.column.value === 'HesapFormulu'"
                  class="ysr-formula-cell"
                  :title="slotProps.item.HesapAciklamasi"
                >
                  <v-icon small>functions</v-icon>
                  <span>{{ slotProps.value || '-' }}</span>
                </div>

                <!-- Yolcu isimleri -->
                <div
                  v-else-if="slotProps.column && slotProps.column.value === 'KisiIsimList'"
                  class="ysr-passenger-list"
                  @click="onCellClick(slotProps.item, slotProps.column)"
                >
                  <div
                    v-for="(isim, index) in splitPassengerNames(slotProps.value)"
                    :key="index"
                    class="ysr-passenger-name"
                  >
                    {{ isim }}
                  </div>
                  <span v-if="splitPassengerNames(slotProps.value).length === 0">-</span>
                </div>

                <!-- Normal hücre -->
                <div
                  v-else
                  class="ysr-click-cell"
                  @click="onCellClick(slotProps.item, slotProps.column)"
                >
                  {{ slotProps.value }}
                </div>
              </template>
            </ReportTable>
          </section>

          <!-- =================================================
               ALT ÖZET
               ================================================= -->
          <section class="ysr-bottom-summary" v-if="hasSearched">
            <div>
              <span>{{ $t('PNR-Total') }}</span>
              <strong>{{ toplamPnr }}</strong>
            </div>

            <div>
              <span>{{ $t('Total-Passengers') }}</span>
              <strong>{{ toplamYolcu }}</strong>
            </div>

            <div>
              <span>{{ $t('Sales') }}</span>
              <strong>{{ formatMoneyDisplay(toplamSatis) }} {{ paraBirimi }}</strong>
            </div>

            <div>
              <span>{{ $t('Cost') }}</span>
              <strong>{{ formatMoneyDisplay(toplamAlis) }} {{ paraBirimi }}</strong>
            </div>

            <div class="ysr-bottom-profit">
              <span>{{ $t('Net-Profit') }}</span>
              <strong>{{ formatMoneyDisplay(toplamKar) }} {{ paraBirimi }}</strong>
            </div>
          </section>
        </v-form>
      </v-container>

      <v-snackbar
        :timeout="timeout"
        :top="true"
        :right="true"
        v-model="snackbar"
      >
        {{ text1 }}
        <v-btn flat color="pink" @click="snackbar = false">
          {{ $t('Close') }}
        </v-btn>
      </v-snackbar>
    </v-app>
  </div>
</template>

<script>
import tarihcomp from "../../customcomp/tarihim";
import helpers from "@/components/app/customcomp/helpers.js";
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import tool from "../../coper/tools";
import hatadialog from "@/components/app/coper/comp/hatadialog.vue";
import genelfiltre from "../comp/genelfiltre.vue";
import ReportTable from "@/components/app/customcomp/ReportTable.vue";

function createDetayHeaders(vm) {
  return [
    { text: "PNR", value: "PNR_No", type: "text", align: "left", visible: true, sortable: true, minWidth: "110px" },
    { text: vm.$t("Reservation-Code"), value: "PNR_RezzKod", type: "text", align: "left", visible: true, sortable: true, minWidth: "130px" },
    { text: vm.$t("Tour-Code"), value: "PNR_TurKodu", type: "text", align: "left", visible: true, sortable: true, minWidth: "120px" },
    { text: vm.$t("Record-Date"), value: "KayitTarihi", type: "date", align: "left", visible: true, sortable: true, minWidth: "130px" },
    { text: vm.$t("Currentcode_label"), value: "PNR_CariKod", type: "text", align: "left", visible: true, sortable: true, minWidth: "140px" },
    { text: vm.$t("Title_label"), value: "CariUnvan", type: "text", align: "left", visible: true, sortable: true, minWidth: "220px" },

    { text: vm.$t("Seller-Type"), value: "SaticiTip", type: "text", align: "left", visible: true, sortable: true, minWidth: "130px" },
    // SP_Rapor2 -> V_Saticilar.Isim -> backend SaticiAd
    // Gerçek otel / transfer / restaurant / diğer satıcı adı burada gösterilir.
    { text: vm.$t("Seller"), value: "SaticiAd", type: "text", align: "left", visible: true, sortable: true, minWidth: "220px" },

    { text: "Pax", value: "Pax", type: "text", align: "right", visible: true, sortable: true, minWidth: "80px" },
    { text: vm.$t("Night-Day"), value: "Gece", type: "text", align: "right", visible: true, sortable: true, minWidth: "100px" },
    { text: vm.$t("Room-Quantity"), value: "Adet", type: "text", align: "right", visible: true, sortable: true, minWidth: "100px" },

    { text: vm.$t("Calculation"), value: "HesapTipi", type: "text", align: "center", visible: true, sortable: true, minWidth: "95px" },
    { text: vm.$t("Formula"), value: "HesapFormulu", type: "text", align: "left", visible: true, sortable: true, minWidth: "190px" },

    { text: vm.$t("Unit-Sales"), value: "BirimSatis", type: "money", align: "right", visible: true, sortable: true, minWidth: "130px" },
    { text: vm.$t("Unit-Purchase"), value: "BirimAlis", type: "money", align: "right", visible: true, sortable: true, minWidth: "130px" },

    { text: vm.$t("Total-Sales"), value: "SatisTutar", type: "money", align: "right", visible: true, sortable: true, minWidth: "140px" },
    { text: vm.$t("Purchase-Total"), value: "AlisTutar", type: "money", align: "right", visible: true, sortable: true, minWidth: "140px" },
    { text: vm.$t("Commission"), value: "KomisyonTutar", type: "money", align: "right", visible: true, sortable: true, minWidth: "130px" },
    { text: vm.$t("Gross-Difference"), value: "BrutKar", type: "money", align: "right", visible: true, sortable: true, minWidth: "130px" },

    { text: vm.$t("Check-In"), value: "Donem1", type: "date", align: "left", visible: true, sortable: true, minWidth: "130px" },
    { text: vm.$t("Check-Out"), value: "Donem2", type: "date", align: "left", visible: true, sortable: true, minWidth: "130px" },

    // Yolcu isimleri backend response'unda zaten KisiIsimList alanında geliyor.
    // Varsayılan olarak kapalıdır; kullanıcı kolon seçiminden isterse açabilir.
    { text: vm.$t("Passenger-Names"), value: "KisiIsimList", type: "text", align: "left", visible: false, sortable: true, minWidth: "220px" },

    { text: vm.$t("Booker"), value: "RezYapan", type: "text", align: "left", visible: true, sortable: true, minWidth: "150px" }
  ];
}

function createPnrHeaders(vm) {
  return [
    { text: "PNR", value: "PNR_No", type: "text", align: "left", visible: true, sortable: true, minWidth: "120px" },
    { text: vm.$t("Reservation-Code"), value: "PNR_RezzKod", type: "text", align: "left", visible: true, sortable: true, minWidth: "130px" },
    { text: vm.$t("Tour-Code"), value: "PNR_TurKodu", type: "text", align: "left", visible: true, sortable: true, minWidth: "120px" },
    { text: vm.$t("Record-Date"), value: "KayitTarihi", type: "date", align: "left", visible: true, sortable: true, minWidth: "130px" },
    { text: vm.$t("Currentcode_label"), value: "PNR_CariKod", type: "text", align: "left", visible: true, sortable: true, minWidth: "140px" },
    { text: vm.$t("Title_label"), value: "CariUnvan", type: "text", align: "left", visible: true, sortable: true, minWidth: "220px" },
    { text: vm.$t("Passenger"), value: "ToplamYolcu", type: "text", align: "right", visible: true, sortable: true, minWidth: "100px" },

    // PNR toplam görünümünde de aynı yolcu isimleri isteğe bağlı açılabilir.
    { text: vm.$t("Passenger-Names"), value: "KisiIsimList", type: "text", align: "left", visible: false, sortable: true, minWidth: "220px" },

    { text: vm.$t("Total-Sales"), value: "ToplamSatis", type: "money", align: "right", visible: true, sortable: true, minWidth: "150px" },
    { text: vm.$t("Purchase-Total"), value: "ToplamAlis", type: "money", align: "right", visible: true, sortable: true, minWidth: "150px" },
    { text: vm.$t("Commission"), value: "ToplamKomisyon", type: "money", align: "right", visible: true, sortable: true, minWidth: "140px" },
    { text: vm.$t("Agency-Commission"), value: "AcenteKomisyon", type: "money", align: "right", visible: true, sortable: true, minWidth: "140px" },
    { text: vm.$t("Net-Profit"), value: "ToplamKar", type: "money", align: "right", visible: true, sortable: true, minWidth: "150px" },
    { text: vm.$t("Profitability") + " %", value: "KarlilikOrani", type: "money", align: "right", visible: true, sortable: true, minWidth: "120px" }
  ];
}

export default {
  name: "YeniSatisRaporu",

  components: {
    tarihcomp,
    yetkidialog,
    hatadialog,
    genelfiltre,
    ReportTable
  },

  data() {
    return {
      valid: true,
      progress: false,
      hasSearched: false,

      itemstarihtip: genelfiltre.IslemTarihTip(),
      tarihTip: 0,
      KayitTarihiBasla: null,
      KayitTarihiBitis: null,

      Rapor: genelfiltre.EmptyPrametre(),
      filtrevarmi: false,

      detayItems: [],
      pnrItems: [],

      raporModu: "detay",

      paraBirimi: "TRY",

      toplamSatis: 0,
      toplamAlis: 0,
      toplamKomisyon: 0,
      toplamAcenteKomisyon: 0,
      toplamKar: 0,
      toplamPnr: 0,
      toplamYolcu: 0,

      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0
      },

      snackbar: false,
      timeout: 7000,
      text1: "",

      dictionary: {
        custom: {
          tarihsec: {
            required: () => this.$t("Please-select-a-date")
          },
          tarihsec1: {
            required: () => this.$t("Please-select-a-date")
          }
        }
      }
    };
  },

  computed: {
    dateRules() {
      return [(v) => !!v || this.$t("Please-select-a-date")];
    },

    currentHeaders() {
      return this.raporModu === "pnr"
        ? createPnrHeaders(this)
        : createDetayHeaders(this);
    },

    currentItems() {
      return this.raporModu === "pnr"
        ? this.pnrItems
        : this.detayItems;
    },

    reportTableStorageKey() {
      // Kolon yapısı değiştiği için storage key v2 yapıldı.
      // Böylece eski kaydedilmiş kolon ayarları yeni Yolcu İsimleri kolonunu ezmez.
      return this.raporModu === "pnr"
        ? "yeni_satis_raporu_pnr_v2"
        : "yeni_satis_raporu_detay_v2";
    },

    excelSummaryConfig() {
      if (this.raporModu === "pnr") {
        return {
          label: this.$t("PNR-Grand-Total"),
          fields: [
            { key: "ToplamSatis", type: "money" },
            { key: "ToplamAlis", type: "money" },
            { key: "ToplamKomisyon", type: "money" },
            { key: "AcenteKomisyon", type: "money" },
            { key: "ToplamKar", type: "money" }
          ]
        };
      }

      return {
        label: this.$t("Item-Total"),
        fields: [
          { key: "SatisTutar", type: "money" },
          { key: "AlisTutar", type: "money" },
          { key: "KomisyonTutar", type: "money" },
          { key: "BrutKar", type: "money" }
        ]
      };
    }
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },

  mounted() {
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);

    const credentialsRaw = window.localStorage.getItem("credentials");

    if (credentialsRaw) {
      try {
        const credentials = JSON.parse(credentialsRaw);

        if (credentials && credentials.ParaBirimi) {
          this.paraBirimi = credentials.ParaBirimi;
        }
      } catch (error) {
        this.paraBirimi = "TRY";
      }
    }

    if (this.sayfayetki.Status !== true) {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc === true) {
            if (this.prevRoute != null) {
              window.open("#" + this.prevRoute, "_self");
            } else {
              window.open("#/", "_self");
            }
          }
        })
        .catch(() => {});
    }
  },

  methods: {
    // Backend'den örneğin:
    // "Baran Aydın/ipek abla/tuğba abla"
    // şeklinde gelen yolcu listesini sadece ekranda alt alta göstermek için böler.
    // Backend verisini değiştirmez ve ekstra API/DB çağrısı yapmaz.
    splitPassengerNames(value) {
      if (!value) {
        return [];
      }

      return String(value)
        .split("/")
        .map((x) => x.trim())
        .filter((x) => x);
    },

    validateDateRange() {
      if (!this.$refs.formYeniSatisRaporu.validate()) {
        return false;
      }

      const bastarih = new Date(this.KayitTarihiBasla);
      const bittarih = new Date(this.KayitTarihiBitis);

      if (bastarih <= bittarih) {
        return true;
      }

      this.text1 = this.$t("start-date-cannot-greater-than-end-date");
      this.snackbar = true;

      return false;
    },

    filtrele() {
      this.$refs.genelfiltre
        .open("")
        .then((confirm) => {
          if (confirm.Status === true) {
            this.filtrevarmi = true;
            this.Rapor = confirm.Rapor;
            this.getList();
          } else {
            this.filtrevarmi = false;
            this.Rapor = confirm.Rapor;
          }
        })
        .catch(() => {});
    },

    createReportParams() {
      return {
        Prm: genelfiltre.ParametreOlustur(
          genelfiltre.RaporTarihAyarla(
            this.Rapor,
            this.tarihTip,
            this.KayitTarihiBasla,
            this.KayitTarihiBitis
          )
        ),

        tumSirketler: this.$refs.genelfiltre.TumSirketlerParametre(),

        sayfaAdi: this.$route.name
      };
    },

    getList() {
      if (!this.validateDateRange()) {
        return;
      }

      this.progress = true;
      this.hasSearched = true;

      const params = this.createReportParams();

      tool.http_post(this, "YeniSatisRaporu", params)
        .then((response) => {
          if (response.body && response.body.Status === true) {
            this.detayItems = response.body.data || [];
            this.pnrItems = response.body.PnrToplamlar || [];

            this.toplamSatis = Number(response.body.ToplamSatis || 0);
            this.toplamAlis = Number(response.body.ToplamAlis || 0);
            this.toplamKomisyon = Number(response.body.ToplamKomisyon || 0);
            this.toplamAcenteKomisyon = Number(response.body.ToplamAcenteKomisyon || 0);
            this.toplamKar = Number(response.body.ToplamKar || 0);

            this.toplamPnr = Number(response.body.ToplamPnr || 0);
            this.toplamYolcu = Number(response.body.ToplamYolcu || 0);

            this.paraBirimi =
              response.body.ParaBirimi ||
              this.resolveRequestCurrency(params) ||
              this.paraBirimi;
          } else {
            this.clearData();

            this.text1 =
              response.body &&
              response.body.ErrorList &&
              response.body.ErrorList.length
                ? response.body.ErrorList[0]
                : this.$t("New-Sales-Report-Could-Not-Be-Prepared");

            this.snackbar = true;
          }
        })
        .catch((response) => {
          this.clearData();
          this.HataYonetimi(
            response,
            params,
            this.$t("New-Sales-Report-Could-Not-Be-Retrieved")
          );
        })
        .then(() => {
          this.progress = false;
        });
    },

    resolveRequestCurrency(params) {
      try {
        return params &&
          params.Prm &&
          params.Prm.PPNR_ParaBirimi
          ? params.Prm.PPNR_ParaBirimi
          : null;
      } catch (e) {
        return null;
      }
    },

    clearData() {
      this.detayItems = [];
      this.pnrItems = [];

      this.toplamSatis = 0;
      this.toplamAlis = 0;
      this.toplamKomisyon = 0;
      this.toplamAcenteKomisyon = 0;
      this.toplamKar = 0;
      this.toplamPnr = 0;
      this.toplamYolcu = 0;
    },

    HataYonetimi(response, request, baslik) {
      if (response && response.status === 500 && this.$refs.hatadialog) {
        this.$refs.hatadialog.open(response, request, baslik);
      } else {
        this.text1 = "Service Unavailable - " + baslik;
        this.snackbar = true;
      }
    },

    onCellClick(item, column) {
      if (!item || !item.PNR_No) {
        return;
      }

      // Formül / hesap hücresine basınca rezervasyona gitme.
      if (
        column &&
        (column.value === "HesapTipi" ||
          column.value === "HesapFormulu")
      ) {
        return;
      }

      const url =
        "#/coper/rezervasyon/index/id?islem=get&PNR_No=" +
        item.PNR_No;

      window.open(url, "_blank");
    },

    hesapTipiClass(value) {
      const tip = String(value || "").toUpperCase();

      if (tip === "PAX") {
        return "ysr-type-pax";
      }

      if (tip === "FIX") {
        return "ysr-type-fix";
      }

      return "ysr-type-total";
    },

    formatMoneyDisplay(value) {
      return helpers.moneyformat(value || 0);
    }
  }
};
</script>

<style scoped>
.ysr-page,
.ysr-app {
  min-height: 100vh;
  background: #f4f7fb !important;
}

.ysr-hero {
  min-height: 118px;
  padding: 26px 34px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  color: #fff;
  background: linear-gradient(135deg, #168fe8 0%, #256fca 100%);
  box-shadow: 0 8px 24px rgba(31, 111, 186, 0.2);
}

.ysr-eyebrow {
  display: block;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 1.5px;
  opacity: 0.78;
}

.ysr-hero h1 {
  margin: 3px 0 4px;
  font-size: 28px;
  line-height: 36px;
  font-weight: 700;
  letter-spacing: -0.4px;
}

.ysr-hero p {
  margin: 0;
  max-width: 760px;
  font-size: 12px;
  line-height: 18px;
  opacity: 0.86;
}

.ysr-engine-badge {
  min-width: 190px;
  padding: 12px 15px;
  display: flex;
  align-items: center;
  gap: 10px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.26);
  background: rgba(255, 255, 255, 0.1);
}

.ysr-engine-badge .v-icon {
  color: #fff;
}

.ysr-engine-badge small,
.ysr-engine-badge strong {
  display: block;
}

.ysr-engine-badge small {
  font-size: 8px;
  letter-spacing: 0.9px;
  opacity: 0.74;
}

.ysr-engine-badge strong {
  margin-top: 2px;
  font-size: 13px;
}

.ysr-container {
  max-width: 1900px;
  margin: 0 auto;
  padding: 22px 28px 38px !important;
}

.ysr-card {
  border: 1px solid #e7edf4;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 6px 18px rgba(31, 41, 55, 0.05);
}

.ysr-filter-card {
  padding: 18px 20px;
}

.ysr-card-heading {
  display: flex;
  align-items: center;
  gap: 12px;
  padding-bottom: 15px;
  margin-bottom: 10px;
  border-bottom: 1px solid #edf1f6;
}

.ysr-heading-icon {
  width: 38px;
  height: 38px;
  flex: 0 0 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: #edf7ff;
}

.ysr-heading-icon .v-icon {
  color: #168fe0;
  font-size: 20px;
}

.ysr-card-heading h2 {
  margin: 0;
  color: #202938;
  font-size: 14px;
  font-weight: 700;
}

.ysr-card-heading p {
  margin: 3px 0 0;
  color: #8a94a6;
  font-size: 10px;
}

.ysr-filter-grid {
  margin: -7px;
}

.ysr-field {
  padding: 7px;
}

.ysr-mode-switch {
  min-height: 42px;
  display: flex;
  align-items: center;
  gap: 7px;
}

.ysr-mode-btn {
  min-height: 36px;
  padding: 0 12px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 1px solid #dce3eb;
  border-radius: 18px;
  background: #fff;
  color: #697586;
  font-size: 10px;
  font-weight: 700;
  cursor: pointer;
  outline: none;
  transition: 0.18s ease;
}

.ysr-mode-btn .v-icon {
  color: #93a0b1;
}

.ysr-mode-btn-active {
  color: #147ec8;
  border-color: #8cc8ef;
  background: #edf8ff;
}

.ysr-mode-btn-active .v-icon {
  color: #168ee0;
}

.ysr-filter-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
}

.ysr-primary-btn,
.ysr-secondary-btn {
  min-height: 40px !important;
  margin: 0 !important;
  border-radius: 9px;
  text-transform: none !important;
  letter-spacing: 0 !important;
  font-weight: 600;
}

.ysr-rule-strip {
  margin-top: 14px;
  padding: 13px 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  border: 1px solid #dce9f5;
  border-radius: 12px;
  background: linear-gradient(90deg, #f5faff 0%, #fbfdff 100%);
}

.ysr-rule-icon {
  width: 36px;
  height: 36px;
  flex: 0 0 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  background: #e5f3ff;
}

.ysr-rule-icon .v-icon {
  color: #268bd5;
  font-size: 19px;
}

.ysr-rule-copy {
  flex: 1;
  min-width: 0;
}

.ysr-rule-copy strong,
.ysr-rule-copy span {
  display: block;
}

.ysr-rule-copy strong {
  color: #314054;
  font-size: 11px;
}

.ysr-rule-copy span {
  margin-top: 2px;
  color: #738095;
  font-size: 9px;
  line-height: 14px;
}

.ysr-rule-examples {
  display: flex;
  gap: 8px;
}

.ysr-rule-examples span {
  padding: 6px 9px;
  border-radius: 999px;
  background: #fff;
  border: 1px solid #e2e9f1;
  color: #647286;
  font-size: 9px;
  white-space: nowrap;
}

.ysr-summary-grid {
  margin: 9px -7px 7px;
}

.ysr-summary-cell {
  padding: 7px;
}

.ysr-summary-card {
  min-height: 88px;
  display: flex;
  align-items: center;
  gap: 13px;
  padding: 16px;
  border: 1px solid #e7edf4;
  border-radius: 13px;
  background: #fff;
  box-shadow: 0 5px 16px rgba(31, 41, 55, 0.045);
}

.ysr-summary-icon {
  width: 42px;
  height: 42px;
  flex: 0 0 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 11px;
}

.ysr-summary-card span,
.ysr-summary-card strong {
  display: block;
}

.ysr-summary-card span {
  margin-bottom: 4px;
  color: #8b96a7;
  font-size: 10px;
}

.ysr-summary-card strong {
  color: #202938;
  font-size: 16px;
  line-height: 21px;
}

.ysr-sales-card .ysr-summary-icon {
  background: #e9f5ff;
}

.ysr-sales-card .ysr-summary-icon .v-icon {
  color: #168edf;
}

.ysr-cost-card .ysr-summary-icon {
  background: #fff0f1;
}

.ysr-cost-card .ysr-summary-icon .v-icon {
  color: #e65b63;
}

.ysr-profit-card .ysr-summary-icon {
  background: #eaf9f1;
}

.ysr-profit-card .ysr-summary-icon .v-icon {
  color: #2da46c;
}

.ysr-pnr-card .ysr-summary-icon {
  background: #f1edff;
}

.ysr-pnr-card .ysr-summary-icon .v-icon {
  color: #7660ce;
}

.ysr-table-card {
  margin-top: 7px;
  overflow: hidden;
}

.ysr-table-header {
  min-height: 70px;
  padding: 15px 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  border-bottom: 1px solid #edf1f6;
}

.ysr-eyebrow-dark {
  display: block;
  margin-bottom: 3px;
  color: #2288d1;
  font-size: 8px;
  font-weight: 800;
  letter-spacing: 1px;
}

.ysr-table-header h2 {
  margin: 0;
  color: #202938;
  font-size: 15px;
}

.ysr-table-count {
  padding: 6px 10px;
  border-radius: 999px;
  background: #f4f7fa;
  color: #748095;
  font-size: 9px;
  white-space: nowrap;
}

.ysr-report-table {
  width: 100%;
}

.ysr-click-cell {
  display: block;
  width: 100%;
  min-height: 24px;
  cursor: pointer;
}

/*
 * Yolcu isimleri '/' karakterinden ayrılarak alt alta gösterilir.
 * Kolon varsayılan olarak kapalıdır ve ReportTable kolon ayarından açılabilir.
 */
.ysr-passenger-list {
  display: block;
  width: 100%;
  min-height: 24px;
  padding: 4px 0;
  line-height: 1.45;
  white-space: normal;
  cursor: pointer;
}

.ysr-passenger-name {
  display: block;
  white-space: nowrap;
}

.ysr-passenger-name + .ysr-passenger-name {
  margin-top: 2px;
}

.ysr-cell-center {
  width: 100%;
  text-align: center;
}

.ysr-type-pill {
  display: inline-flex;
  min-width: 48px;
  justify-content: center;
  padding: 4px 8px;
  border-radius: 999px;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.4px;
}

.ysr-type-pax {
  color: #1976b8;
  background: #e7f4fe;
}

.ysr-type-fix {
  color: #6952b9;
  background: #f0ecff;
}

.ysr-type-total {
  color: #677487;
  background: #eef1f5;
}

.ysr-formula-cell {
  min-height: 24px;
  display: flex;
  align-items: center;
  gap: 6px;
  color: #4e6075;
  font-size: 10px;
}

.ysr-formula-cell .v-icon {
  color: #7e91a8;
}

.ysr-bottom-summary {
  margin-top: 14px;
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  overflow: hidden;
  border: 1px solid #e4eaf1;
  border-radius: 12px;
  background: #fff;
}

.ysr-bottom-summary > div {
  min-width: 150px;
  padding: 11px 15px;
  border-left: 1px solid #edf1f5;
}

.ysr-bottom-summary span,
.ysr-bottom-summary strong {
  display: block;
}

.ysr-bottom-summary span {
  color: #8a95a5;
  font-size: 8px;
  text-transform: uppercase;
  letter-spacing: 0.45px;
}

.ysr-bottom-summary strong {
  margin-top: 3px;
  color: #293548;
  font-size: 12px;
}

.ysr-bottom-profit {
  background: #eef8f3;
}

.ysr-bottom-profit strong {
  color: #278c5d !important;
}

@media (max-width: 1263px) {
  .ysr-filter-actions {
    justify-content: flex-start;
  }

  .ysr-rule-strip {
    align-items: flex-start;
    flex-wrap: wrap;
  }
}

@media (max-width: 760px) {
  .ysr-hero {
    padding: 20px;
  }

  .ysr-engine-badge {
    display: none;
  }

  .ysr-container {
    padding: 14px !important;
  }

  .ysr-rule-examples {
    width: 100%;
    flex-wrap: wrap;
  }

  .ysr-filter-actions {
    width: 100%;
    flex-direction: column;
    align-items: stretch;
  }

  .ysr-primary-btn,
  .ysr-secondary-btn {
    width: 100%;
  }

  .ysr-bottom-summary {
    justify-content: flex-start;
  }

  .ysr-bottom-summary > div {
    width: 50%;
    border-bottom: 1px solid #edf1f5;
  }
}
</style>
